import Backbone from 'backbone';
import _ from 'underscore';
import template from './moreConversionClarityButtons.pug';

export class MoreConversionClarityButtonsContextualAttributeView extends Backbone.View {
  initialize({
    conversionClarityButtons,
    newI18n,
  }) {
    this.conversionClarityButtons = conversionClarityButtons;
    this.newI18n = newI18n;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const {
      conversionClarityButtons,
    } = this;

    const conversionClarityButtonsWithoutFirst = conversionClarityButtons.slice(1);

    const displayPopupclarityEventGoalSettings = [];
    _.each(conversionClarityButtonsWithoutFirst, (conversionClarityButton) => {
      const {
        SourceURL,
        Text,
      } = conversionClarityButton;

      const buttonTextElement = `<span id="clarityEventButtonText">"${Text}"</span>`;
      const clarityEventGoalSetting = this.newI18n.getString(_TL_('Button {0} on')).replace('{0}', buttonTextElement);
      displayPopupclarityEventGoalSettings.push({ clarityEventGoalSetting, sourceURL: SourceURL });
    });

    this.$el.html(template({
      displayPopupclarityEventGoalSettings,
    }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
